import classNames from 'classnames';
import React from 'react';

import './ThemedListWrapper.scss';

type Props = {
    children: React.ReactNode | React.ReactNode[];
    className?: string;
    title?: React.ReactNode;
};

const ThemedListWrapper: React.FC<Props> = ({ title, children, className }) => {
    return (
        <div className={classNames('themed-list-wrapper', 'future-payments-widget', className)}>
            <div className="themed-list-wrapper__header">
                {title && <div className="themed-list-wrapper__title">{title}</div>}
                <div className={classNames('themed-list-wrapper__background-wrapper', { 'with-title': !!title })}>
                    <div className="themed-list-wrapper__background" />
                </div>
            </div>
            <div className="themed-list-wrapper__content">{children}</div>
        </div>
    );
};

export default ThemedListWrapper;
